import axios, { AxiosError } from 'axios';
import { DEFAULT_INTERNAL_ERROR_MESSAGE } from 'core/utils/constants';

const ALLOW_LIST = [400, 409, 422, 429];

export const getErrorMessage = (error: unknown): string | undefined => {
    if (axios.isAxiosError(error)) {
        const axiosErr = error as AxiosError<any>;

        if (axiosErr.response?.data?.message) {
            // Only allow specific error messages to be passed to the user
            if (!ALLOW_LIST.includes(axiosErr.response.status)) {
                return DEFAULT_INTERNAL_ERROR_MESSAGE;
            }

            return axiosErr.response.data.message;
        }

        return axiosErr.message;
    }

    if (error instanceof Error) {
        return error.message;
    }

    if (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof (error as any).message === 'string'
    ) {
        return (error as any).message;
    }

    if (typeof error === 'string') {
        return error;
    }

    return undefined;
};
